import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {DeploymentWorkflowService} from "./deployment-workflow.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {SuccessComponent} from "../../errors/success.component";
import {initialPagecountsStatusFactory, InitialPagecountsStatusModel} from "./initial-pagecounts.model";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";

@Component({
  templateUrl: "./initial-pagecounts.template.pug",
  providers: [DeploymentWorkflowService],
})
export class InitialPagecountsComponent extends WorkflowStep {
  private isReady: boolean = false;

  public deploymentId: string = "";
  public projectId: string = "";
  public disableStep: boolean = false;
  public error: Error;
  public status: InitialPagecountsStatusModel;
  public message: string;

  @ViewChild(SuccessComponent) success: SuccessComponent;

  @handleErrors()
  public async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.isReady = true;
    this.deploymentId = workflowTargetInfo.targetId;
    this.projectId = workflowTargetInfo.projectId;
    this.status = initialPagecountsStatusFactory(
      await this.deploymentWorkflowService.getInitialPagecountsStatus(this.deploymentId).toPromise(),
    );
    if (this.status.done) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
      this.message = `Step Complete: All ${this.status.manualCollectAssetsTotal} ` +
        "manual collect asset(s) have initial collections";
    } else {
      this.message = "Please add initial manual collections to " +
         `the ${this.status.manualCollectAssetsNotCollectedButInRM} ` +
        `manual asset(s) in Usage Service, and the ${this.status.manualCollectAssetsNotInRM} asset(s) not yet in ` +
        " Usage Service. The report below gives information for the relevant assets";
    }
    this.loading = false;
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public deploymentWorkflowService: DeploymentWorkflowService,
  ) {
    super(true);
  }
}
